import React from "react"
import StoreLocatorPage from "./components/StoreLocatorPage"

const CuaHang: React.FC = () => {
  return <StoreLocatorPage />
}

export default CuaHang
